<template>
    <bottom-sheet v-model="shows" fullscreen persistent title="리본바이옴 판매 계약서">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-tabs-items v-model="tab" class="fill-height">
            <v-tab-item value="form" class="fill-height">
                <sign-form v-model="form" @input="emit" @setDisabled="(value) => (disabled_form = value)" />
            </v-tab-item>
            <v-tab-item value="file" class="fill-height">
                <sign-file v-model="form" @input="emit" @setDisabled="(value) => (disabled_file = value)" />
            </v-tab-item>
        </v-tabs-items>

        <template #foot>
            <v-tabs-items v-model="tab" style="width: 100%">
                <v-tab-item value="form">
                    <v-row class="row--sm">
                        <v-col cols="6">
                            <v-btn v-bind="{ loading }" block color="grey lighten-3" outlined class="v-size--xx-large rounded" @click="exit">
                                <span class="grey--text">취소</span>
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <template v-if="hasFile">
                                <v-btn v-bind="{ loading, disabled: disabled_form }" block color="primary" class="v-size--xx-large rounded" @click="tab = 'file'">
                                    <span>다음</span>
                                </v-btn>
                            </template>
                            <template v-else>
                                <v-btn v-bind="{ loading, disabled: disabled_form }" block color="primary" class="v-size--xx-large rounded" @click="save">
                                    <span>저장</span>
                                </v-btn>
                            </template>
                        </v-col>
                    </v-row>
                </v-tab-item>
                <v-tab-item value="file">
                    <v-row class="row--sm">
                        <v-col cols="6">
                            <v-btn v-bind="{ loading }" block color="grey lighten-3" outlined class="v-size--xx-large rounded" @click="tab = 'form'">
                                <span class="grey--text">이전</span>
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn v-bind="{ loading, disabled: disabled_file }" block color="primary" class="v-size--xx-large rounded" @click="save">
                                <span>저장</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-tab-item>
            </v-tabs-items>
        </template>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

import BottomSheet from "@/components/client/dumb/bottom-sheet.vue";
import SignFile from "./sign/sign-file.vue";
import SignForm from "./sign/sign-form.vue";

export default {
    components: {
        BottomSheet,
        SignFile,
        SignForm,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        form: initEmploymentContract(),

        tab: "form",
        shows: false,
        loading: false,
        disabled_form: undefined,
        disabled_file: undefined,
    }),
    computed: {
        hasFile() {
            return this.form.fields_employee.some((item) => item.type == EMPLOYMENT_FIELD_TYPES.FILE.value);
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { contract } = await api.v1.me.employment.contract.get();
                this.form = initEmploymentContract(contract);
                this.tab = "form";
            } finally {
                this.loading = false;
            }
        },

        async save() {
            if (!this.validate()) return;

            let go = confirm("서명 완료 후 더 이상 수정하실 수 없습니다.\n서명하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;
            try {
                let { _id, fields_employee } = this.form;

                fields_employee = await Promise.all(
                    fields_employee.map(async (item) => {
                        switch (item.type) {
                            case EMPLOYMENT_FIELD_TYPES.FILE.value: {
                                if (item.file instanceof File) {
                                    item.file = (await api.v1.me.employment.files.post({ code: item.type }, item.file))?.file;
                                }
                                item._file = item?.file?._id || null;
                                delete item.file;
                                break;
                            }
                            case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                                if (item.img instanceof File) {
                                    item.img = (await api.v1.me.employment.files.post({ code: item.type }, item.img))?.file;
                                }
                                item._img = item?.img?._id || null;
                                delete item.img;
                                break;
                            }
                        }

                        return item;
                    })
                );

                let { contract } = await api.v1.me.employment.contract.put({ _id, fields_employee });
                this.form = initEmploymentContract(contract);

                alert("계약서의 서명을 완료하였습니다");

                this.loading = false;
                this.exit();
                this.$emit("init");
            } finally {
                this.loading = false;
            }
        },

        validate() {
            const fields_required = this.form.fields_employee.filter((item) => item.isRequired);
            const fields_unfilled = fields_required.filter((item) => {
                switch (item.type) {
                    case EMPLOYMENT_FIELD_TYPES.CBOX.value: {
                        return !item.data;
                    }
                    case EMPLOYMENT_FIELD_TYPES.DATE.value: {
                        return !item.data;
                    }
                    case EMPLOYMENT_FIELD_TYPES.FILE.value: {
                        return !item.file;
                    }
                    case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                        return !item.img;
                    }
                    case EMPLOYMENT_FIELD_TYPES.TEXT.value: {
                        return !item.data;
                    }
                }
            });

            if (0 < fields_unfilled.length) {
                alert(`필수입력 필드 ${fields_required.length}개 중 ${fields_unfilled.length}개가 입력되지 않았습니다.`);
                return false;
            }

            return true;
        },

        exit() {
            this.shows = false;
        },

        emit() {
            this.form = initEmploymentContract(this.form);
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>

<style lang="scss" scoped></style>
